document.addEventListener('DOMContentLoaded', function() {
    const readMoreBtn = document.getElementById('read-more-btn');
    const closeBtn = document.getElementById('close-btn');
    const contentWrapper = document.querySelector('.content-wrapper');
    const controlOpen = document.querySelector('.--open');
    const controlClose = document.querySelector('.--close');
    
    // Event listener for read more button
    readMoreBtn.addEventListener('click', function() {
        contentWrapper.classList.add('expanded');
        controlOpen.style.display = 'none';
        controlClose.style.display = 'block';
    });
    
    // Event listener for close button
    closeBtn.addEventListener('click', function() {
        contentWrapper.classList.remove('expanded');
        controlClose.style.display = 'none';
        controlOpen.style.display = 'block';
    });
});